import { inject, Injectable, InjectionToken } from '@angular/core';
import { IWorkflowDefinitionModelProvider } from './IWorkflowDefinitionProvider';

export const WorkflowDefinitionModelProviderToken = new InjectionToken<
    IWorkflowDefinitionModelProvider[]
>('WorkflowDefinitionProvider');

export const DefaultStepEditorsMap = {};

@Injectable({ providedIn: 'root' })
export class WorkflowDefinitionsService {
    private providers = inject(WorkflowDefinitionModelProviderToken, {
        optional: true,
    });

    constructor() {
        const providers = this.providers;

        if (!providers?.length) {
            throw new Error(
                'No workflow definition model providers found. Please provide at least one provider.'
            );
        }
    }

    getDefinitionModelProvider(modelName: string) {
        if (!this.providers) {
            throw new Error('No workflow definition model providers');
        }
        return this.providers.find(provider => provider.name === modelName);
    }
}
